// Sub-foldere pentru documentele fiecărui angajat (structură HR)
export const DOC_FOLDERS = [
  { id: "oferte_angajare", label: "1. Oferte angajare" },
  { id: "cim", label: "2. CIM, acte adiționale și declarații" },
  { id: "acte_personale", label: "3. Acte personale" },
  { id: "acte_studii", label: "4. Acte studii" },
  { id: "pv_echipamente", label: "5. PV-uri echipamente" },
  { id: "fisa_postului", label: "6. Fișa postului" },
  { id: "fise_riscuri", label: "7. Fișe riscuri" },
  { id: "reges", label: "8. Reges" },
  { id: "adeverinte", label: "9. Adeverințe" },
  { id: "concedii", label: "10. Concedii" },
  { id: "popriri", label: "11. Popriri" },
  { id: "deplasari", label: "12. Deplasări" },
];

// Sub-foldere pentru documentele colaboratorilor (regim de colaborare)
export const COLLAB_FOLDERS = [
  { id: "col_oferte_colaborare", label: "1. Oferte colaborare" },
  { id: "col_cps_acte_aditionale", label: "2. CPS și acte adiționale" },
  { id: "col_acte_personale_firma", label: "3. Acte personale și firmă" },
  { id: "col_acte_studii", label: "4. Acte studii" },
  { id: "col_pv_echipamente", label: "5. PV-uri echipamente" },
  { id: "col_vacante", label: "6. Vacanțe" },
  { id: "col_deplasari", label: "7. Deplasări" },
];

// Etichete pentru ambele seturi (folosit la fallback / afișare)
export const FOLDER_LABEL = [...DOC_FOLDERS, ...COLLAB_FOLDERS]
  .reduce((m, f) => { m[f.id] = f.label; return m; }, {});

export const UNFILED = { id: "__unfiled__", label: "Neîncadrate" };

// Setul de foldere în funcție de tipul de persoană
export const foldersFor = (mode) => (mode === "collaborators" ? COLLAB_FOLDERS : DOC_FOLDERS);
